import { useEffect, useState } from "react";
import { TableCell, Typography } from "@mui/material";
import { PRC_WELL } from "../../utils/PRC_WELL";

export const GetSDEnum = ({ controller, type, icon }) => {
  const [value, setValue] = useState("");

  useEffect(() => {
    let isMounted = true;

    async function fetchData() {
      try {
        const data = await PRC_WELL.getSDAsync();
        if (isMounted) {
          if (type === "C5") {
            setValue(data?.C5?.[controller.value] ?? "-");
          } else {
            setValue(data?.WP?.[controller.value] ?? "-");
          }
        }
      } catch (err) {
        console.error(err);
      }
    }

    fetchData();

    return () => {
      isMounted = false;
    };
  }, [controller.value]);

  return (
    <Typography sx={{ fontSize: 14 }}>
      {value} {icon}
    </Typography>
  );
};
